import { ReconciliationMissingDateOrBalanceError } from "@common/contracts/reconciliation.contract";
import { ErrorToast } from "@design-system/ToastMessages/ErrorToast";

interface Props {
    error: ReconciliationMissingDateOrBalanceError;
}

export const ReconciliationMissingDateOrBalanceErrorToast = ({
    error,
}: Props) => (
    <ErrorToast>
        <div>
            Opening/closing date or balance missing for file {error.fileName}.
        </div>
    </ErrorToast>
);
